module.exports = __webpack_public_path__ + "img/cross.add9951f.svg";